module.exports = __webpack_public_path__ + "static/media/icon-nfe.1c29c3b6.svg";